import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { IconSC } from 'atoms/Icon'
import { PosterSC } from 'atoms/ImagePoster'
import { LabelStyled } from 'atoms/Label'
import { Paddings } from 'atoms/Label/Label.h'
import {
  BaseCardSC,
  CardPosterSize,
  ImageBackgroundSC,
  PosterContainerSC,
} from 'blocks/Cards'
import { SimpleLabelGroupSC } from 'blocks/LabelGroup'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'
import {
  LockedPosterSC,
  PosterContainerContentSC,
} from '../base-card/BaseCard.styled'
import { TVCardContent } from './TVCardDefault.styled'

export const TVCardEPGSC = styled.div<{
  height?: string
  width?: string
  backgroundColorForLogo?: COLOR
}>`
  width: ${({ width }) => width!};
  height: ${({ height }) => height!};

  & ${BaseCardSC} {
    ${PosterContainerSC} {
      & ${ImageBackgroundSC} {
        width: ${() => `${CardPosterSize.TvPosterEPGContainerHeight}%`};
        height: ${() => `${CardPosterSize.TvPosterEPGContainerHeight}%`};
        background-color: ${({ backgroundColorForLogo }) =>
          `var(${backgroundColorForLogo})`};
        left: 50%;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        border: 0.2px solid var(${COLOR.SURFACE_OPACITY_LIGHT_15});
        overflow: hidden;

        ${MEDIA.MIN_1240} {
          width: ${() => `${CardPosterSize.TvPosterEPGContainerWidth}%`};
        }

        ${PosterSC} {
          width: ${() => `${CardPosterSize.TvPosterEPGWidth}%`};
          height: ${() => `${CardPosterSize.TvPosterEPGWidth}%`};
        }

        ${LockedPosterSC} {
          ${IconSC} {
            width: ${() => `${CardPosterSize.TvPosterEPGWidth}%`};
            height: ${() => `${CardPosterSize.TvPosterEPGWidth}%`};
          }
        }
      }

      ${PosterContainerContentSC} {
        padding: var(${FIXED_INDENTS.INDENT_50});
      }

      ${LockedPosterSC} {
        ${IconSC} {
          width: 100%;
          height: 100%;
        }
      }

      ${SimpleLabelGroupSC} {
        ${LabelStyled} {
          padding: ${Paddings.SIZE_50.join(' ')};
        }
      }
    }

    ${TVCardContent} {
      ${ButtonSC} {
        ${IconSC} {
          margin: 0;
        }
      }
    }
  }
`
